export default function (eventProduct) {
  return [
    "cancelled",
    "public_registrations_disabled",
    "registration_limit_reached",
    "registration_closed"
  ].includes(eventProduct.registrationStatus);
}
